import { axios2 } from "@/lib/axios"

export const sendConractLawyer = (data) => {
    return axios2.post(`/lawyer-api/create-do-it-lawyer-contract`,data)
}